var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"chart"}},[_vm._v(" members: "+_vm._s(_vm.members)+" tree: "+_vm._s(_vm.tree)+" "),_c('div',{ref:"tree",attrs:{"id":"tree"}})])}
var staticRenderFns = []

export { render, staticRenderFns }